import { IDS } from '../adm-categorisation-action-id.constants';
import * as CentersActions from './adm-cat-centers.actions';
import * as GRID from "../../../../common/grid/grid.constants";
import {TAB_SHOW} from "../../../../common/tabs/tabs.constants";
import {TYPES} from "../adm-categorisation-action-type.constants";
import {fetchCenterTypeModules} from "./adm-cat-centers.actions";

/**
 * Creates a new AdmCatCentersController.
 * @class
 */
class AdmCatCentersController {
    constructor($ngRedux, $state, $scope, $mdDialog, $uiRouterGlobals, Notifier, NavigationService) {
        this.$ngRedux           = $ngRedux;
        this.$state             = $state;
        this.$scope             = $scope;
        this.$uiRouterGlobals   = $uiRouterGlobals;
        this.$mdDialog          = $mdDialog;
        this.Notifier           = Notifier;
        this.NavigationService  = NavigationService;
    }

    $onInit() {
        this.module         = 'administration';
        this.identifier     = IDS.admCategorisation;
        this.statePath      = IDS.admCatCentersGrid;
        this.unsubscribe    = this.$ngRedux.connect(
            state => {
                const admCategorisation = state.administration.admCategorisation;

                return {
                    admCategorisation,
                }
            },
            CentersActions
        )(this);

        const navConfig = this.NavigationService.getConfig(this.$state.$current)
        this.colorName = navConfig.colorName;
    }

    onAssignButton() {
        if(this.selectedHofUsedAlready === false) {
            this.assignRegulatoryFrameworkToSiteLocation(this.schemeId, this.selectedHeadOfficeUuid).then(() => {
                this.getNotEnabledHeadOffices(this.schemeId);
            });
        }
    }

    onSelect({item}) {
        this.$ngRedux.dispatch({
            type: TYPES.CENTER_DETAILS_REFRESH,
            id: this.identifier,
            item
        });
        this.fetchCenterTypeModules(item.sty_id).then(() => {
            this.$ngRedux.dispatch({
                type: TAB_SHOW,
                id: IDS.app_administration_categorisation_centers,
                state: [
                    IDS.app_administration_categorisation_centers_details
                   ,IDS.app_administration_categorisation_centers_modules
                ],
                stateParams: {sty_id: item.sty_id}
            });
        });
    }

    $onDestroy() {
        this.unsubscribe();
        if (this.dialog)
            this.$mdDialog.hide(this.dialog);
    }
}

AdmCatCentersController.$inject = ['$ngRedux', '$state', '$scope', '$mdDialog', '$uiRouterGlobals', 'Notifier', 'NavigationService']

export const admCatCenters = {
    controller: AdmCatCentersController,
    template: `
        <adm-cat-centers-grid
            module="$ctrl.module"
            identifier="$ctrl.identifier"
            state-path="$ctrl.statePath"
            on-select="$ctrl.onSelect($event)"
            on-remove="$ctrl.onRemove($event)">
        </adm-cat-centers-grid>

        <tabs-navigation identifier="app.administration.categorisation.centers"
                         state="app.administration.categorisation.centers.grid"
                         on-exec="$ctrl.addNewCenterType()">
        </tabs-navigation>
`}
